import { UserType, UserTypeEnum } from './enums/UserTypesEnum';

export type ProjectUser = {
  id: string;
  userType: UserType;
  name: string;
  emailAddress: string;
  accessToken: string;
  projectId: string;
};

export type ProjectUsers = Array<ProjectUser>;

export const DefaultProjectUser: ProjectUser = {
  id: '',
  userType: UserTypeEnum.Captioner,
  name: '',
  emailAddress: '',
  accessToken: '',
  projectId: '',
};
